import QuestionBehavior from './QuestionBehavior';

export * from './actions';
export default QuestionBehavior;
